import LoginForm from '../components/LoginForm/LoginForm'

export default function LoginPage(props) {

  return (
    <LoginForm />
  )
}